import React from 'react'
import { Package, Search, ShoppingBag } from 'lucide-react'

const EmptyProductsState: React.FC = () => {
	return (
		<div className='relative flex flex-col items-center justify-center py-12 px-4 sm:py-16 lg:py-20 min-h-[400px] sm:min-h-[500px] overflow-hidden'>
			<div className='absolute inset-0 -z-10'>
				<div className='absolute top-1/4 left-1/4 w-32 h-32 sm:w-48 sm:h-48 bg-gradient-to-br from-blue-50 to-indigo-100 rounded-full opacity-40 blur-2xl animate-pulse'></div>
				<div className='absolute bottom-1/4 right-1/4 w-40 h-40 sm:w-56 sm:h-56 bg-gradient-to-br from-purple-50 to-pink-100 rounded-full opacity-30 blur-2xl animate-pulse delay-1000'></div>
				<div className='absolute top-3/4 left-1/2 transform -translate-x-1/2 w-24 h-24 sm:w-32 sm:h-32 bg-gradient-to-br from-emerald-50 to-teal-100 rounded-full opacity-35 blur-xl animate-pulse delay-500'></div>
			</div>

			<div className='absolute inset-0 -z-5 pointer-events-none'>
				<div className='absolute top-1/3 left-1/6 opacity-10 animate-bounce delay-300'>
					<ShoppingBag className='w-6 h-6 sm:w-8 sm:h-8 text-gray-400' />
				</div>
				<div className='absolute top-1/2 right-1/6 opacity-10 animate-bounce delay-700'>
					<Search className='w-5 h-5 sm:w-7 sm:h-7 text-gray-400' />
				</div>
				<div className='absolute bottom-1/3 left-1/3 opacity-10 animate-bounce delay-1000'>
					<Package className='w-4 h-4 sm:w-6 sm:h-6 text-gray-400' />
				</div>
			</div>

			<div className='relative z-10 text-center max-w-sm sm:max-w-md lg:max-w-lg mx-auto'>
				<div className='relative mx-auto mb-6 sm:mb-8'>
					<div className='flex items-center justify-center w-24 h-24 sm:w-28 sm:h-28 lg:w-32 lg:h-32 bg-gradient-to-br from-gray-50 via-gray-100 to-gray-200 rounded-full shadow-lg border border-gray-200/50 backdrop-blur-sm'>
						<div className='flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 lg:w-22 lg:h-22 bg-gradient-to-br from-red-50 to-orange-100 rounded-full'>
							<Package className='w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 text-red-500 stroke-[1.5]' />
						</div>
					</div>

					<div className='absolute inset-0 rounded-full border-2 border-dashed border-gray-300/40 animate-spin-slow'></div>
				</div>

				<div className='space-y-3 sm:space-y-4 lg:space-y-5'>
					<h3 className='text-lg sm:text-xl lg:text-2xl xl:text-3xl font-bold bg-gradient-to-r from-gray-800 via-gray-900 to-gray-800 bg-clip-text text-transparent leading-tight'>
						No hay productos disponibles
					</h3>

					<div className='space-y-2 sm:space-y-3'>
						<p className='text-sm sm:text-base lg:text-lg text-gray-600 leading-relaxed font-medium'>
							No encontramos productos que coincidan con tu búsqueda
						</p>

						<p className='text-xs sm:text-sm lg:text-base text-gray-500 leading-relaxed'>
							Intenta ajustar los filtros o explora otras categorías de nuestro
							equipamiento deportivo
						</p>
					</div>
				</div>

				<div className='flex justify-center items-center space-x-2 sm:space-x-3 mt-8 sm:mt-10'>
					<div className='w-2 h-2 sm:w-3 sm:h-3 bg-gradient-to-r from-blue-400 to-purple-500 rounded-full animate-pulse'></div>
					<div className='w-1.5 h-1.5 sm:w-2 sm:h-2 bg-gradient-to-r from-purple-400 to-pink-500 rounded-full animate-pulse delay-200'></div>
					<div className='w-2 h-2 sm:w-3 sm:h-3 bg-gradient-to-r from-pink-400 to-red-500 rounded-full animate-pulse delay-400'></div>
				</div>
			</div>

			<div className='absolute bottom-0 left-0 right-0 h-20 sm:h-24 bg-gradient-to-t from-white via-white/80 to-transparent pointer-events-none'></div>
		</div>
	)
}

export default EmptyProductsState
